import React from 'react';
import Card from '@dashboard/components/Card';
import CardHeader from '@dashboard/components/CardHeader';
import CardHeaderTitle from '@dashboard/components/CardHeaderTitle';
import CardContent from '@dashboard/components/CardContent';
import SettingsDescription from '@dashboard/components/SettingsDescription';

import GeneralSettingsForm from './components/GeneralSettingsForm';
import SettingsContainer from '@/dashboard/components/SettingsContainer';

const SettingsGeneral = () => {
  return (
    <Card variant="root">
      <CardHeader variant="root">
        <div className="flex flex-col max-w-lg">
          <CardHeaderTitle variant="root">General</CardHeaderTitle>
          <SettingsDescription className="mt-2">
            Manage your store's branding and appearance, and set your default currency and homepage.
          </SettingsDescription>
        </div>
      </CardHeader>

      <CardContent variant="root" className="mt-4 mb-32">
        <SettingsContainer size="lg">
          <GeneralSettingsForm />
        </SettingsContainer>
      </CardContent>
    </Card>
  );
};

export default SettingsGeneral;
